import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { LoadingSpinner } from './components/LoadingSpinner';
import { THEME } from './colors';

export default function RootRedirect() {
  const { currentUser, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="p-8 flex flex-col items-center justify-center gap-3">
        <LoadingSpinner size="lg" />
        <div style={{ color: THEME.dark.text.primary }}>Loading...</div>
      </div>
    );
  }

  // If user is logged in, redirect to albums, otherwise to login
  return currentUser ? <Navigate to="/albums" replace /> : <Navigate to="/login" replace />;
}
